/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_item" | "PdpRespTradeIconBubbles_item">;
    readonly " $refType": "PdpRespIconBubblesWrapper_item";
};
export type PdpRespIconBubblesWrapper_item$data = PdpRespIconBubblesWrapper_item;
export type PdpRespIconBubblesWrapper_item$key = {
    readonly " $data"?: PdpRespIconBubblesWrapper_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubblesWrapper_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespIconBubblesWrapper_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_item",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'f772fc672a6929d8b888ed1950bbfa1e';
export default node;
